import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib/core/store';
import { createSlice } from '@reduxjs/toolkit';

export const pmZoneSitesUiSlice = createSlice({
  name: 'pmZoneSites-ui',
  initialState: {
    ...baseUiInitialState,
  },
  reducers: {
    ...baseUiReducers,
  },
});
